<tt-page>
    <tt-page-heading> {{ (purchheadservice.currentPurchHead$ | async)?.purch_heading }} </tt-page-heading>
    <tt-purch-head (submit)="onSubmit($event)"></tt-purch-head>
</tt-page>
